<template>
  <el-row>
    <el-col :span="5">
      <basic-container>
        <avue-tree :option="treeOption" :data="treeData" @node-click="nodeClick" />
      </basic-container>
    </el-col>
    <el-col :span="19">
      <basic-container>
        <avue-crud
          :option="option"
          :table-loading="loading"
          :data="data"
          ref="crud"
          v-model="form"
          :permission="permissionList"
          @row-del="rowDel"
          @row-update="rowUpdate"
          @row-save="rowSave"
          :before-open="beforeOpen"
          :page.sync="page"
          @search-change="searchChange"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="refreshChange"
          @on-load="onLoad"
        >
          <template slot="menu" slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-warning"
              @click.native="openPropertyEditDialog(0, scope.row)"
              >不可见</el-button
            >
            <el-button
              type="text"
              size="small"
              icon="el-icon-view"
              @click.native="openPropertyEditDialog(1, scope.row)"
              >查看</el-button
            >
            <el-button
              type="text"
              icon="el-icon-edit"
              size="small"
              @click.native="openPropertyEditDialog(2, scope.row)"
              >读写</el-button
            >
            <el-button
              type="text"
              size="small"
              icon="el-icon-refresh"
              @click.native="openPropertyEditDialog(3, scope.row)"
              >读写删</el-button
            >
          </template>
        </avue-crud>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getDeptTree,
} from '@/api/v4ward/deptproperty/basedeptproperty';
import { mapGetters } from 'vuex';
import website from '@/config/website';

export default {
  data() {
    return {
      form: {},
      selectionList: [],
      query: {},
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      init: {
        // roleTree: [],
        deptTree: [],
      },
      treeDeptId: '',
      treeDeptName: '',
      treeData: [],
      treeOption: {
        nodeKey: 'id',
        addBtn: false,
        menu: false,
        size: 'small',
        props: {
          labelText: '标题',
          label: 'title',
          value: 'value',
          children: 'children',
        },
      },
      option: {
        height: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        selection: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        sarchShow: true,
        searchMenuSpan: 6,
        calcHeight: 50,
        menuWidth: 300,
        rowKey: 'objectId',
        dialogType: 'drawer',
        column: [
          {
            label: '小区编号',
            type: 'input',
            prop: 'objectCode',
            span: website.tenantMode ? 12 : 24,
          },

          {
            label: '小区',
            prop: 'propertyId',
            hide: true,
          },
          {
            label: '小区名称',
            prop: 'objectName',
            cell: true,
            search: true,
            span: website.tenantMode ? 12 : 24,
          },

          {
            label: '权限',
            prop: 'dataPower',
            type: 'checkbox',
            dataType: 'number',
            dicData: [
              {
                label: '  ',
                value: -1,
              },
              {
                label: '不可看',
                value: 0,
              },
              {
                label: '可看',
                value: 1,
              },
              {
                label: '读写',
                value: 2,
              },
              {
                label: '读写删',
                value: 3,
              },
            ],
          },
          {
            label: 'id',
            prop: 'id',
            hide: true,
          },
          {
            label: '小区id',
            prop: 'objectId',
            hide: true,
          },
          {
            label: '部门id',
            prop: 'deptId',
            hide: true,
          },
        ],
      },
      data: [],
    };
  },
  watch: {
    'form.tenantId'() {
      if (this.form.tenantId !== '') {
      }
    },
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.deptproperty_add, false),
        viewBtn: this.vaildData(this.permission.deptproperty_view, false),
        delBtn: this.vaildData(this.permission.deptproperty_delete, false),
        editBtn: this.vaildData(this.permission.deptproperty_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.initData();
  },
  methods: {
    nodeClick(data) {
      this.treeDeptId = data.id;
      this.treeDeptName = data.title;
      this.page.currentPage = 1;
      this.data = []; //此行代码用于解决测试出现的bug（点击某些节点后，再点击别的节点前端报错而一直加载）
      this.onLoad(this.page);
    },
    initData() {
      getDeptTree().then((res) => {
        this.treeData = res.data;
      });
    },
    rowSave(row, loading, done) {
      row.deptId = row.deptId.join(',');
      row.roleId = row.roleId.join(',');
      add(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      row.deptId = row.deptId.join(',');
      row.roleId = row.roleId.join(',');
      update(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        });
    },

    openPropertyEditDialog(type, row) {
      let typeName;
      let treeDeptId = this.treeDeptId;
      if (0 === type) {
        typeName = '不可见';
      } else if (1 === type) {
        typeName = '查看';
      } else if (2 === type) {
        typeName = '读写';
      } else if (3 === type) {
        typeName = '读写删';
      }
      if (row.usableArea === type) {
        return;
      }
      if (null === treeDeptId || 'undefined' == typeof treeDeptId || '' === treeDeptId) {
        this.$message.warning('请在左边选择至少一个组织');
        return;
      }
      row.deptId = treeDeptId;
      row.usableArea = this.treeDeptName;
      row.grantRemark = type;
      this.$confirm('确定将选择小区权限修改为' + typeName, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })

        .then(() => {
          return update(row);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        });
    },
    searchReset() {
      this.query = {};
      this.treeDeptId = '';
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
          this.$refs.crud.toggleSelection();
        });
    },
    handleReset() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择账号密码重置为123456?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return resetPassword(this.ids);
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getdeptproperty(this.form.id).then((res) => {
          this.form = res.data;
          this.form.deptId = this.form.deptId.split(',');
          this.form.deptId.forEach((ele, index) => {
            this.form.deptId[index] = Number(ele);
          });
          this.form.roleId = this.form.roleId.split(',');
          this.form.roleId.forEach((ele, index) => {
            this.form.roleId[index] = Number(ele);
          });
        });
      }
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize, deptId: this.treeDeptId },
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style></style>
